var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 0C7.55228 0 8 0.447715 8 1V2H16V1C16 0.447715 16.4477 0 17 0C17.5523 0 18 0.447715 18 1V2H19C21.2091 2 23 3.79086 23 6V19C23 21.2091 21.2091 23 19 23H5C2.79086 23 1 21.2091 1 19V6C1 3.79086 2.79086 2 5 2H6V1C6 0.447715 6.44772 0 7 0ZM5 4C3.89543 4 3 4.89543 3 6V7H21V6C21 4.89543 20.1046 4 19 4H5ZM21 9H3V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V9ZM6.5 13C6.5 12.4477 6.94772 12 7.5 12H9.5C10.0523 12 10.5 12.4477 10.5 13C10.5 13.5523 10.0523 14 9.5 14H7.5C6.94772 14 6.5 13.5523 6.5 13ZM13.5 13C13.5 12.4477 13.9477 12 14.5 12H16.5C17.0523 12 17.5 12.4477 17.5 13C17.5 13.5523 17.0523 14 16.5 14H14.5C13.9477 14 13.5 13.5523 13.5 13ZM6.5 17C6.5 16.4477 6.94772 16 7.5 16H9.5C10.0523 16 10.5 16.4477 10.5 17C10.5 17.5523 10.0523 18 9.5 18H7.5C6.94772 18 6.5 17.5523 6.5 17ZM13.5 17C13.5 16.4477 13.9477 16 14.5 16H16.5C17.0523 16 17.5 16.4477 17.5 17C17.5 17.5523 17.0523 18 16.5 18H14.5C13.9477 18 13.5 17.5523 13.5 17Z",
    fill: "#A0AEBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIc);
export default __webpack_public_path__ + "static/media/calendar_ic.91887b63e90a24996e899091c5fc7788.svg";
export { ForwardRef as ReactComponent };